import type { SchemaInput, SchemaRecord } from '../shared/schema-input.js';
import { isObject, isString } from '../shared/runtime-values.js';

function queryType(query: string): string {
  if (!query) return 'unknown';
  if (/^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/.test(query)) return 'coordinates';
  if (/^https?:\/\/(www\.)?(google\.[a-z.]+\/maps|maps\.app\.goo\.gl)\//i.test(query)) return 'maps_url';
  return 'text';
}

function queryScript(query: string): string {
  if (!query) return 'unknown';
  if (/^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/.test(query)) return 'numeric';
  const hasHan = /\p{Script=Han}/u.test(query);
  const hasLatin = /\p{Script=Latin}/u.test(query);
  if (hasHan && hasLatin) return 'mixed';
  if (hasHan) return 'han';
  if (hasLatin) return 'latin';
  return 'other';
}

export function searchAnalyticsProps(query: string, geocoderContext: SchemaInput = null) {
  const trimmed = query.trim();
  const providerProps: Record<string, string> = {};
  if (geocoderContext && isObject(geocoderContext)) {
    // SAFETY: The adjacent object and field checks validate this boundary value before it is accepted.
    const context = geocoderContext as SchemaRecord;
    if (isString(context.geocoderProvider)) providerProps.provider = context.geocoderProvider.slice(0, 40);
    if (isString(context.geocoderFallbackFrom)) providerProps.fallback_from = context.geocoderFallbackFrom.slice(0, 40);
    if (isString(context.geocoderFallbackTrigger)) providerProps.fallback_trigger = context.geocoderFallbackTrigger.slice(0, 80);
  }
  return {
    query_length: String(Math.min(trimmed.length, 999)),
    query_type: queryType(trimmed),
    query_script: queryScript(trimmed),
    ...providerProps,
  };
}
